<template>
  <div>
    <a-form layout="inline" :model="formState" style="margin-bottom: 10px">
      <a-form-item label="用户名">
        <a-input
          v-model:value="formState.userName"
          placeholder="输入检索用户名"
          allow-clear
        />
      </a-form-item>
      <a-form-item label="账号">
        <a-input
          v-model:value="formState.account"
          placeholder="输入检索账号"
          allow-clear
        />
      </a-form-item>
      <a-form-item label="手机号码">
        <a-input
          v-model:value="formState.phone"
          placeholder="输入精确手机号码"
          allow-clear
        />
      </a-form-item>
      <a-form-item label="部门" style="min-width: 300px">
        <a-tree-select
          v-model:value="formState.departId"
          show-search
          placeholder="请选择部门"
          allow-clear
          tree-default-expand-all
          :tree-data="treeData"
          tree-node-filter-prop="name"
          :fieldNames="{ label: 'name', value: 'depart_id' }"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        />
        <!-- <a-select
          v-model:value="formState.depart_id"
          placeholder="请选择部门"
          allow-clear
        >
          <a-select-option
            v-for="item in treeData"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select> -->
      </a-form-item>
      <a-form-item label="状态">
        <a-radio-group v-model:value="formState.status">
          <a-radio-button value="">不限</a-radio-button>
          <a-radio-button :value="1">启用</a-radio-button>
          <a-radio-button :value="0">禁用</a-radio-button>
        </a-radio-group>
      </a-form-item>

      <a-form-item>
        <a-button type="primary" @click="handelSearch" v-if="ableSearch">检索</a-button>
      </a-form-item>
      <a-form-item style="position: absolute; right: 50px" v-if="ableAdd">
        <a-button type="primary" @click="showAddModal">添加用户</a-button>
      </a-form-item>
    </a-form>
    <a-modal
      v-model:open="open"
      :title="isEdit ? '编辑用户' : '添加用户'"
      :footer="null"
      :destroyOnClose="true"
    >
      <add-user
        :v-if="open"
        @submit="handelEditOk"
        :isEdit="isEdit"
        :editData="editData"
        :treeData="treeData"
      ></add-user>
    </a-modal>
    <a-modal
      v-model:open="roleOpen"
      title="绑定角色"
      :footer="null"
      :destroyOnClose="true"
    >
      <bind-role
        :v-if="roleOpen"
        @submit="handelBindOk"
        :editData="editData"
      ></bind-role>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'gender'">
          {{ record.gender ? '女' : '男' }}
        </template>
        <template v-else-if="column.key === 'depart_id'">
          {{ getDeptName(record) }}
        </template>
        <template v-else-if="column.key === 'status'">
          {{ record.status ? '启用' : '禁用' }}
        </template>
        <template v-if="column.key === 'main_liaison'">
          {{ record.main_liaison === 0 ? '否' : '是' }}
        </template>
        <template v-else-if="column.key === 'action'">
          <span>
            <a-button @click="showEditModal(record)" v-if="ableEdit">编辑</a-button>
            <a-button @click="showRoleModal(record)" v-if="ableBind">角色</a-button>
            <a-popconfirm
              title="确认删除？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="delRow(record)"
              v-if="ableDelete"
            >
              <a-button danger>删除</a-button>
            </a-popconfirm>
          </span>
        </template>
      </template>
    </a-table>
  </div>
</template>
<script setup>
  import { ref, reactive, onMounted, computed } from 'vue'
  import { useStore } from 'vuex'
  import { getUser, deleteUser } from '@/api/system_manage/userManage'
  import { getDept } from '@/api/system_manage/dept'
  import { buildTree } from '@/utils/tree'
  import AddUser from './addUser'
  import BindRole from './bindRole'
  import { message } from 'ant-design-vue'
  const store = useStore()

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    !!permissionList.value?.find(item => item.code === 'user:list')
  )
  const ableAdd = computed(() =>
    !!permissionList.value?.find(item => item.code === 'user:add')
  )
  const ableEdit = computed(() =>
    !!permissionList.value?.find(item => item.code === 'user:edit')
  )
  const ableDelete = computed(() =>
    !!permissionList.value?.find(item => item.code === 'user:delete')
  )
  const ableBind = computed(() =>
    !!permissionList.value?.find(item => item.code === 'user:bindRole')
  )

  //1、检索
  const formState = reactive({
    userName: '',
    account: '',
    phone: '',
    status: '',
    departId: undefined,
  })
  function handelSearch() {
    pagination.value.current = 1
    fetch()
  }

  //2、表格
  const columns = [
    {
      title: '用户名',
      dataIndex: 'user_name',
      key: 'user_name',
      align: 'left',
    },
    {
      title: '账号',
      dataIndex: 'account',
      key: 'account',
      align: 'left',
    },
    {
      title: '性别',
      dataIndex: 'gender',
      key: 'gender',
      align: 'left',
    },
    {
      title: '手机号码',
      dataIndex: 'phone',
      key: 'phone',
      align: 'left',
    },
    {
      title: '部门',
      dataIndex: 'depart_id',
      key: 'depart_id',
      align: 'left',
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      align: 'left',
    },
    {
      title: '总联络员',
      dataIndex: 'main_liaison',
      key: 'main_liaison',
      align: 'left',
    },
    {
      title: '职务',
      dataIndex: 'job',
      key: 'job',
      align: 'left',
    },
    {
      title: '备注',
      dataIndex: 'remark',
      key: 'remark',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
    },
  ]
  const dept = ref([])
  const tableData = ref([])
  const treeData = ref([])
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })
  const loading = ref(false)
  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }
  function getDeptName(data) {
    if (!data || !dept.value?.length) return ''
    return dept.value.find((item) => item.depart_id === data.depart_id)?.name
  }
  function fetch() {
    loading.value = true
    getUser({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      pagination.value.total = data.total
      loading.value = false
      tableData.value = data.list
    })
    getDept().then(({ data }) => {
      const tree = buildTree(data, { idName: 'depart_id' })
      dept.value = data
      treeData.value = tree
    })
  }
  onMounted(fetch)

  //3、添加、编辑
  const open = ref(false)
  const isEdit = ref(false)
  const editData = ref(null)
  const showAddModal = () => {
    editData.value = null
    isEdit.value = false
    open.value = true
  }
  const showEditModal = (data) => {
    editData.value = data
    isEdit.value = true
    open.value = true
  }
  const editOk = () => {
    open.value = false
  }
  function clearEditData() {
    editData.value = null
  }
  function handelEditOk() {
    fetch()
    editOk()
    clearEditData()
  }

  //4、绑定角色
  const roleOpen = ref(false)
  const showRoleModal = (data) => {
    editData.value = data
    roleOpen.value = true
  }
  const bindOk = () => {
    roleOpen.value = false
  }
  function handelBindOk() {
    fetch()
    bindOk()
    clearEditData()
  }

  //5、删除
  async function delRow(data) {
    const res = await deleteUser({ userId: data.user_id })
    if (res.success) {
      message.success('删除成功！')
      fetch()
    } else {
      message.warn('删除失败' + res.message)
    }
  }
</script>
